module.exports = __webpack_public_path__ + "img/jne.1e9c346e.png";